import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IUploadedProForma } from 'types/db/UploadedProForma';

interface IParams {
    organizationUuid: string;
    uploadedProFormaId: number;
}

const getUploadedProForma = async ({ organizationUuid, uploadedProFormaId }: IParams): Promise<IUploadedProForma> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.UPLOADED_PRO_FORMAS_BY_ID(organizationUuid, uploadedProFormaId)}`);
    return response.data;
};

const useGetUploadedProForma = (organizationUuid: string, uploadedProFormaId: number, options?: any) => useQuery<IUploadedProForma>({
    queryKey: ['UploadedProForma', organizationUuid, uploadedProFormaId],
    queryFn: () => getUploadedProForma({ organizationUuid, uploadedProFormaId }),
    ...options,
});

export default useGetUploadedProForma;
